// extracted by mini-css-extract-plugin
module.exports = {"label_input":"form-input_label_input__20xpd","input":"form-input_input__21eY-","input_error":"form-input_input_error__2AFmJ","text_error":"form-input_text_error__1Yi-T"};